import React, { PropsWithChildren } from 'react';
import { cn } from '@kiiwi/ui';

interface ProCardContainerProps {
  disabled?: boolean;
  className?: string;
  onMouseEnter?: React.ReactEventHandler;
  onMouseLeave?: React.ReactEventHandler;
  onClick?: React.ReactEventHandler;
}

const ProCardContainer = ({
  disabled,
  children,
  className,
  onMouseEnter,
  onMouseLeave,
  onClick,
}: PropsWithChildren<ProCardContainerProps>) => {
  const isContainerClickable = onClick && !disabled;

  return (
    <div
      className={cn(
        'relative flex w-[inherit] flex-1 gap-4 rounded-lg border border-neutral bg-surface-white p-3 text-neutral-primary',
        isContainerClickable && 'cursor-pointer [&_*]:cursor-pointer',
        disabled &&
          'cursor-not-allowed opacity-50 [&_*]:pointer-events-none [&_*]:cursor-not-allowed',
        className,
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={isContainerClickable ? onClick : undefined}
    >
      {children}
    </div>
  );
};

ProCardContainer.displayName = 'ProCardContainer';

export default ProCardContainer;
